//imports
import { all } from 'redux-saga/effects';

//Views
import newMigrationSagas from 'Modules/importP4/views/main/.components/newMigration/redux/saga';
import exceptionDetailsSagas from 'Modules/importP4/views/main/.components/exceptionDetails/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        newMigrationSagas(),
        exceptionDetailsSagas(),
    ]);
}